import * as queryString from 'query-string';

export const createWidgetLink = (
  domain: string,
  qs?: Record<string, string | number | boolean>
): string => {
  let urlString = domain;
  if (domain) {
    urlString = ['https://', domain].join('');
  }

  return queryString.stringifyUrl({
    url: urlString,
    query: qs,
  });
};
